import { MdClose } from 'react-icons/md';
import Button from './../ui/Button';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export default function WarningModal({ isOpen, onClose, children }: ModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 pb-20"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-2xl rounded-xl bg-white p-30 shadow-xl"
      >
        <Button
          onClick={onClose}
          variant="ghost"
          size="sm"
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 p-2"
          aria-label="Close modal"
        >
          <MdClose className="h-7 w-7" />
        </Button>
        <div className="text-center">
          {children}
        </div>
      </div>
    </div>
  );
}